// O CompraComigo (marketplace; código interno "negocios") roda no mesmo domínio
// do MoraComigo, sob /compracomigo. Mesma build, mesmo backend, mesma sessão:
// o caminho decide qual árvore de rotas é montada (ver App.js).
export const COMPRACOMIGO_BASE = "/compracomigo";

export function isCompraComigoPath(pathname) {
  const p = (pathname || "").toLowerCase();
  return p === COMPRACOMIGO_BASE || p.startsWith(`${COMPRACOMIGO_BASE}/`);
}

export function isCompraComigoSite() {
  if (typeof window === "undefined") return false;
  return isCompraComigoPath(window.location.pathname);
}

// URL absoluta de uma página do CompraComigo (links de compartilhamento, canonical).
export function compraComigoUrl(path = "/") {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}${COMPRACOMIGO_BASE}${path === "/" ? "" : path}`;
}
